module.exports = __webpack_public_path__ + "img/web.png.cd88affa.svg";